import { Card } from "@destroy/ui";
import { LuShieldCheck, LuTriangleAlert, LuShieldAlert, LuCircleHelp } from "react-icons/lu";
import type { DomainHealthSummary } from "../_types";

interface HealthSummaryCardProps {
  summary: DomainHealthSummary["summary"];
}

export function HealthSummaryCard({ summary }: HealthSummaryCardProps) {
  const stats = [
    {
      label: "Healthy",
      count: summary.healthy,
      icon: LuShieldCheck,
      color: "text-[var(--color-success)]",
      bgColor: "bg-[var(--color-success)]/10",
    },
    {
      label: "Warning",
      count: summary.warning,
      icon: LuTriangleAlert,
      color: "text-[var(--color-warning)]",
      bgColor: "bg-[var(--color-warning)]/10",
    },
    {
      label: "Blocked",
      count: summary.blocked,
      icon: LuShieldAlert,
      color: "text-[var(--color-error)]",
      bgColor: "bg-[var(--color-error)]/10",
    },
    {
      label: "Unknown",
      count: summary.unknown,
      icon: LuCircleHelp,
      color: "text-[var(--color-text-muted)]",
      bgColor: "bg-[var(--color-surface)]",
    },
  ];

  return (
    <Card padding="md">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.label} className="text-center">
              <div className={`w-10 h-10 mx-auto mb-2 rounded-full ${stat.bgColor} flex items-center justify-center`}>
                <Icon className={`w-5 h-5 ${stat.color}`} />
              </div>
              <p className="text-2xl font-semibold text-[var(--color-text)]">{stat.count}</p>
              <p className="text-xs text-[var(--color-text-muted)]">{stat.label}</p>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
